import {LivelihoodInformation} from '../model/livelihood-information.model';
import {LivelihoodInformationService} from '../service/livelihood-information.service';
import {Injectable} from '@angular/core';
import {LoanApplicationInteractor} from './loan-application.interactor';
import {LoanApplicationDocumentType} from '../model/loan-application-document-type.model';
import {Proof} from '../model/Proof';

@Injectable()
export class LivelihoodInformationInteractor {
    constructor(private readonly livelihoodInformationService: LivelihoodInformationService, private loanApplicationInteractor: LoanApplicationInteractor) {
    }

    public async createOrUpdateLivelihoodInformation(livelihoodInformation: LivelihoodInformation): Promise<LivelihoodInformation> {
        if (!livelihoodInformation.id) {
            return await this.livelihoodInformationService.create(livelihoodInformation);
        } else {
            await this.livelihoodInformationService.update(livelihoodInformation);
            // TODO call /livelihood-information/id instead
            return await this.livelihoodInformationService.getByLoanApplicationId(livelihoodInformation.loanApplicationId);
        }
    }

    public async getByLoanApplicationId(id: string): Promise<LivelihoodInformation> {
        return await this.livelihoodInformationService.getByLoanApplicationId(id);
    }

    public async updateLivelihoodDocuments(documentType: LoanApplicationDocumentType, fileIds: string[]): Promise<void> {
        const loanApplication = await this.loanApplicationInteractor.get();
        const livelihoodInformation = await this.livelihoodInformationService.getByLoanApplicationId(loanApplication.id);
        livelihoodInformation.proofs = await this.getLivelihoodInformationProof(documentType,
            livelihoodInformation.proofs, fileIds);
        await this.update(livelihoodInformation);
    }
    public async removeLivelihoodDocuments(documentType: LoanApplicationDocumentType, fileId: string): Promise<void> {
        const loanApplication = await this.loanApplicationInteractor.get();
        const livelihoodInformation = await this.livelihoodInformationService.getByLoanApplicationId(loanApplication.id);
        livelihoodInformation.proofs = await this.removeFileFromLivelihoodInformation(documentType, livelihoodInformation.proofs, fileId);
        await this.update(livelihoodInformation);
    }

    private getProofsByType(documentType: LoanApplicationDocumentType | string, proofs: Proof[]) {
        if (!proofs) {
            return;
        }
        return proofs.find(item => item.proofType === documentType);
    }

    private async getLivelihoodInformationProof(documentType: LoanApplicationDocumentType,
                                                proofs: Proof[], fileIds: string[]): Promise<Proof[]> {
        let proof = this.getProofsByType(documentType, proofs);
        if (proof) {
            proof.fileIds.push(...fileIds);
        } else {
            proof = new Proof(documentType);
            proof.fileIds = fileIds;
            proofs ? proofs.push(proof) : proofs = [proof];
        }
        return proofs;
    }

    public async removeFileFromLivelihoodInformation(documentType: LoanApplicationDocumentType, proofs: Proof[], fileId: string) {
        const proof = this.getProofsByType(documentType, proofs);
        if (proof) {
            if (proof.fileIds.length > 1) {
                proof.fileIds.splice(proof.fileIds.indexOf(fileId), 1);
            } else {
                proofs.splice(proofs.indexOf(proof), 1);
            }
        }
        return proofs;
    }

    private async update(livelihoodInformation: LivelihoodInformation) {
        await this.livelihoodInformationService.update(livelihoodInformation);
    }
}
